const repeat3Regex = /(.)\1\1/; // 3 repeticiones consecutivas

export const getNameTokens = (fullName = '') =>
  fullName
    .toLowerCase()
    .split(/[\s,.;-]+/)
    .filter(t => t.length >= 3);

export const passwordPolicyCheck = (password = '', { nombreCompleto = '', correoInstitucional = '' } = {}) => {
  const checks = {
    length: password.length >= 12,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    digit: /\d/.test(password),
    special: /[!@#$%^&*()\-_=+\[\]{};:'",.<>/?\\|`~]/.test(password),
    noSpaces: !/\s/.test(password),
    noRepeats: !repeat3Regex.test(password),
    noPersonal: true,
  };

  const emailLocal = (correoInstitucional || '').toLowerCase().split('@')[0] || '';
  const tokens = getNameTokens(nombreCompleto);
  const pwdLower = (password || '').toLowerCase();

  if (emailLocal && emailLocal.length >= 3 && pwdLower.includes(emailLocal)) {
    checks.noPersonal = false;
  } else {
    for (const t of tokens) {
      if (pwdLower.includes(t)) {
        checks.noPersonal = false;
        break;
      }
    }
  }

  const valid = Object.values(checks).every(Boolean);
  return { valid, checks };
};

export const checksToArray = (checks) => ([
  { ok: checks.length,   label: 'Mínimo 12 caracteres' },
  { ok: checks.upper,    label: 'Al menos 1 mayúscula (A-Z)' },
  { ok: checks.lower,    label: 'Al menos 1 minúscula (a-z)' },
  { ok: checks.digit,    label: 'Al menos 1 número (0-9)' },
  { ok: checks.special,  label: 'Al menos 1 símbolo' },
  { ok: checks.noSpaces, label: 'Sin espacios' },
  { ok: checks.noRepeats,label: 'Sin 3+ repetidos consecutivos' },
  { ok: checks.noPersonal,label:'No contenga tu nombre ni el usuario del correo' },
]);
